/**
 * Fixes a memory leak with PhotoSwipe. When a page is opened in the issue 
 * reading view, and PhotoSwipe instances are created, PhotoSwipe caches the 
 * images. When the page is destroyed (after browsing away from that page), 
 * the cache is not purged.
 */
( function() {
  
  "use strict";
  
  if ( !window.Code || !window.Code.PhotoSwipe )
    throw 'PhotoSwipe is not loaded';
  
  jQuery( window ).on( 'pagePreRemove', function( event, pageIndex ) {
  
    if ( typeof window.pages !== 'object' || !pages[ pageIndex ] )
      return;
    
    var imgs = $( '#asmag-page-'+ pages[ pageIndex ].id +' img' );
    var instances = window.Code.PhotoSwipe.instances;
    
    for ( var i = 0; i < instances.length; i++ ) {
      var origImages = $( instances[ i ].originalImages );
      if ( origImages.is( imgs ) || origImages.find( 'img' ).is( imgs ) ) {
        window.Code.PhotoSwipe.unsetActivateInstance( instances[ i ] );
        window.Code.PhotoSwipe.detatch( instances[ i ] );
        // We removed the instance from the instances array, so we must 
        // backtrack the iteration to prevent overshooting
        i--;
      }
    }
  } );
  
} )();